export default "__VITE_ASSET__CT50wy8z__"